<template>
    <v-card>
        <v-card-title>{{ $t('choose_fk') }}</v-card-title>
        <v-card-subtitle
            >Die Förderkategorie bestimmt die Parameter für Ihr Projekt. Wählen
            Sie:</v-card-subtitle
        >
        <v-card-text>
            <FkGruppeList
                v-model:model-value="modelValue"
                :kanton-kuerzel="kanton ? kanton.kuerzel : null"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="action white--text"
                variant="flat"
                @click="$emit('back')"
                prepend-icon="fas fa-arrow-left"
            >
                {{ $t('back') }}
            </v-btn>
            <v-btn
                color="action white--text"
                variant="flat"
                :disabled="!modelValue"
                @click="$emit('next')"
                append-icon="fas fa-arrow-right"
            >
                {{ $t('next') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import type { ApollonConfFk } from '@/models/ApollonConfFk'
import type { Kanton } from '@/models/Kanton'
import FkGruppeList from '@/components/foerderkategorie-config-list.vue'

const modelValue = defineModel<ApollonConfFk[] | null>()

const { kanton } = defineProps<{
    kanton: Kanton | null
}>()

defineEmits<{
    (e: 'next'): void
    (e: 'back'): void
}>()
</script>
